import { css } from '@emotion/css';

export const emptyInputStyles = css`
  input {
    width: 100% !important;
  }
`;

export const inputRootStyles = css`
  width: 20rem;
`;
